import { useState } from 'react';
import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';
import Input from '~/components/newInput';
import TextArea from '~/components/textarea';

interface StatusReasonContentProps {
  placeholder: string;
  onConfirm: (reason: string | null) => void;
  confirmationWord?: 'ativar' | 'desativar';
}

export function StatusReasonContent({
  placeholder,
  confirmationWord,
  onConfirm,
}: StatusReasonContentProps) {
  const [reason, setReason] = useState('');
  const [confirmationText, setConfirmationText] = useState('');
  const isConfirmationValid = confirmationWord
    ? confirmationText.trim() === confirmationWord
    : true;
  return (
    <>
      <ContainerFlex marginBottom={6}>
        <TextArea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          label="Motivo"
          placeholder={placeholder}
        />
      </ContainerFlex>
      {confirmationWord ? (
        <ContainerFlex marginTop={12}>
          <Input
            labelStyle={{
              fontSize: '1.2em',
              color:
                confirmationText && !isConfirmationValid ? '#ff1a1a' : 'black',
              marginBottom: '4px',
            }}
            style={{ fontSize: '1.1em' }}
            label={`Digite "${confirmationWord}" para continuar`}
            value={confirmationText}
            onChange={(e) => setConfirmationText(e.target.value)}
            placeholder={confirmationWord}
            errorMessage={
              confirmationText && !isConfirmationValid
                ? `Digite exatamente "${confirmationWord}"`
                : ''
            }
          />
        </ContainerFlex>
      ) : null}

      <ContainerFlex marginTop={16} row horizontal space center gap="16">
        <Button outlined onClick={() => onConfirm(null)}>
          Voltar
        </Button>
        <Button
          disabled={!isConfirmationValid}
          onClick={() => onConfirm(reason)}
        >
          Confirmar
        </Button>
      </ContainerFlex>
    </>
  );
}
